import FuseSvgIcon from '@fuse/core/FuseSvgIcon'
import React from 'react'
import { makeStyles } from "@mui/styles"
import clsx from 'clsx'
import { Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    root: {
        borderTop: `1px solid rgba(241,245,249,.12)`,
        borderBottom: `1px solid rgba(241,245,249,.12)`,
        padding: '15px 0',

        '& li': {
            padding: '0 25px',
            textAlign: 'center',

            '& svg': {
                margin: 'auto'
            }
        },
        '& li.active': {
            color: `${theme.palette.primary.main}`,
        },
        '& li.preview': {
            opacity: '0.4'
        }
    },
}));

const Steps = (props) => {
    const classes = useStyles(props);
    return (
        <div className={clsx(classes.root)}>
            <ul className='flex items-end'>
                <li className='active'>
                    <span><FuseSvgIcon size={24}>heroicons-outline:check-circle</FuseSvgIcon></span>
                    <Typography variant="body">Request Brief</Typography>
                </li>
                <li>
                    <span><FuseSvgIcon size={24}>heroicons-outline:check</FuseSvgIcon></span>
                    <Typography variant="body">Date & Time selection</Typography>
                </li>
                {/* <li>
                    <span></span>
                    <Typography variant="body">Space planning</Typography>
                </li>
                <li>
                    <span></span>
                    <Typography variant="body">Review</Typography>
                </li>
                <li>
                    <span></span>
                    <Typography variant="body">Individual Kitchen Design</Typography>
                </li>
                <li>
                    <span></span>
                    <Typography variant="body">Review</Typography>
                </li> */}
            </ul>
        </div>
    )
}

export default Steps